var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-arrow_right"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow_right",
    clipPath: "url(#clip-arrow_right)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6609",
    "data-name": "Group 6609",
    transform: "translate(457.846 369.355) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21192",
    "data-name": "Path 21192",
    d: "M105.108,7.969l-6.236,6.236a1.016,1.016,0,0,1-1.436-1.436l5.518-5.518L97.436,1.734A1.016,1.016,0,0,1,98.872.3l6.236,6.236a1.016,1.016,0,0,1,0,1.436Z",
    transform: "translate(548.695 366.428) rotate(180)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite);
export default __webpack_public_path__ + "static/media/arrow_right_white.3b98cf1f34e825cae9db566720be3ac2.svg";
export { ForwardRef as ReactComponent };